<p class="block-full-width__title">
    {{'MEDIUM_STEP_ENTER_EMAIL_TITLE' | translate}}</p>
<p class="block-full-width-message__content__description"
    >
    {{'MEDIUM_STEP_ENTER_EMAIL_DESCRIPTION' | translate}}
</p>

<div class="travel-card">
    <div class="travel-card-area">
        <ridango-form-field class="form-margin-10">
            <input class="text-input" ridangoInput [formControl]="emailForm.controls.email" name="email"
                (change)="change()" #emailInput [required]="required">
            <ridango-label>{{'PH_EMAIL' | translate}}</ridango-label>
            <ridango-error *ngIf="emailForm.controls.email.hasError('required')">
                {{'FIELD_VALIDATION_REQUIRED' | translate}}
            </ridango-error>
            <ridango-error *ngIf="emailForm.controls.email.hasError('email')">
                {{'LOCAL_INPUT_VALIDATION_EMAIL' | translate}}
            </ridango-error>
        </ridango-form-field>
    </div>
</div>